// extracted by mini-css-extract-plugin
export var container = "_9z-0";
export var icon = "_9z-1";
export var text = "_9z-2";